/**
 * Returns a promise that will resolve in the amount of milliseconds specified
 * @param {number} milliseconds - The amount of time to sleep in milliseconds
 * @returns {Promise}
 */
export function sleep (milliseconds) {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}
